import { FlexCenHorVer } from '@/UI/styles';
import { ImageList } from '../../Common/ImageList/ImageList';
import type { DeleteFunctions } from '@/components/Common/ImageList/types';
import type { RenderingAsset, UploadedAsset } from '@/types/api/assets';

function DesignAppGallery({
  mediaArray,
  recipeName,
  selected,
  setSelected,
  deletionFunctions,
}: {
  mediaArray: (UploadedAsset | RenderingAsset)[];
  recipeName: string;
  selected: number;
  setSelected: React.Dispatch<React.SetStateAction<number>>;
  deletionFunctions?: DeleteFunctions;
}) {
  const indexedMediaArray = mediaArray.map((media, index) => ({
    ...media,
    globalIndex: index,
  }));

  return (
    <FlexCenHorVer
      id="design-app-gallery-container"
      sx={{
        width: '100%',
        height: '100%',
        background: 'none',
        position: 'relative',
        overflowX: 'hidden',
      }}
    >
      <ImageList
        nodeName={recipeName}
        images={indexedMediaArray}
        selected={selected}
        setSelected={setSelected}
        container="design-app"
        deletionFunctions={deletionFunctions}
        showHeader
      />
    </FlexCenHorVer>
  );
}

export default DesignAppGallery;
